import config from 'constants/config'

import { getSearchVerticalFromPathname } from 'lib/search/searchUtils'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import { useLocation } from 'react-router'
import { isDestinationSearchPage, isMetaSearchPage } from '../../Search/utils'

// once this gets rolled out to all verticals, delete this hook and replace it with an isMobile + feature flag check
function useSlimMobileSearch() {
  const isEnabled = config.ENABLE_SLIM_MOBILE_SEARCH
  const isMobile = useScreenSizeOnly('mobile')
  const pathname = useLocation().pathname
  const isHotelSearch = getSearchVerticalFromPathname(pathname) === 'hotels'
  const isCruiseSearch = getSearchVerticalFromPathname(pathname) === 'cruises'
  return isEnabled && isMobile && (isHotelSearch || isCruiseSearch || isDestinationSearchPage(pathname) || isMetaSearchPage(pathname))
}

export default useSlimMobileSearch
